/**
 * @flow
 * @format
 */
/* eslint-disable react/no-multi-comp */
import React from 'react';
import { Col, Input, FormGroup, Label } from 'reactstrap';
import _ from 'lodash';

import { branch, createHTMLMarkup } from '~/utils';
import Aux from '~/utils/react-aux';

import RevertInput from '../RevertInput';

import classes from './FieldRadioGroup.scss';
import fieldWrapperClasses from '../FieldWrapper/FieldWrapper.scss';

type OptionsType = {
  display: string,
  key: string,
  name: string,
  value: string | number,
};

type PropsType = {
  changed: boolean,
  changeInput: Function,
  defaultVal: string | number | null,
  error: string[],
  fieldName: string | React$Element<*>,
  options: Array<OptionsType>,
  revertInput: Function,
  tooltip: any,
  value: any,
};
type FGPropsType = {
  checked: boolean,
  onChange: Function,
  name: string,
  value: any,
};
class FormGroupInput extends React.PureComponent<FGPropsType, *> {
  props: FGPropsType;

  // shouldComponentUpdate(nextProps: FGPropsType) {
  //   console.log(nextProps);
  // }

  render() {
    const { value, checked, onChange, name } = this.props;
    return (
      <FormGroup check>
        <Label check>
          <Input
            type="radio"
            value={value}
            checked={checked}
            onChange={onChange}
          />{' '}
          {createHTMLMarkup(name)}
        </Label>
      </FormGroup>
    );
  }
}

export class FieldRadioGroup extends React.PureComponent<PropsType, *> {
  static defaultProps = {
    options: [],
    error: [],
    tooltip: null,
  };

  props: PropsType;

  render() {
    const hasError = this.props.error.length > 0;
    const ref = this;

    const options = this.props.options.map((opt: OptionsType) => {
      const checked = _.toString(opt.key) === _.toString(ref.props.value);
      return (
        <FormGroupInput
          key={opt.key}
          value={opt.key}
          checked={checked}
          onChange={ref.props.changeInput}
          name={opt.name || opt.display}
        />
      );
    });

    const canRevert =
      this.props.changed || this.props.value !== this.props.defaultVal;

    const getRevertNameFromValue = () => {
      const val = this.props.defaultVal;
      const opt: ?OptionsType = this.props.options.find(i => i.key === val);

      if (!opt) return val;
      return opt.display || opt.name || val;
    };

    const recommendedDiv = (
      <RevertInput
        className={fieldWrapperClasses.inputGroupDefault}
        value={getRevertNameFromValue()}
        enable={canRevert}
        onClick={this.props.revertInput}
      />
    );

    return (
      <Aux>
        <Col sm={process.env.REACT_APP_LEFT_PANE_SIZE}>
          <div className="d-flex">{this.props.fieldName}</div>
        </Col>
        <Col>
          <div className={fieldWrapperClasses.infoIconWrapper}>
            {this.props.tooltip}
          </div>
          <FormGroup tag="fieldset" className={classes.formGroup}>
            {options}
            {branch(
              hasError,
              <div className={fieldWrapperClasses.errorBlock}>
                Error: {this.props.error}
              </div>,
            )}
            <div className={fieldWrapperClasses.inputGroupColumn}>
              {recommendedDiv}
            </div>
          </FormGroup>
        </Col>
      </Aux>
    );
  }
}

export default FieldRadioGroup;



// WEBPACK FOOTER //
// ./src/components/FieldRadioGroup/FieldRadioGroup.js